// later, more languages can be added here
import deLabels from "./de_labels";

export const defaultLang = "de"; // default language, could be 'en' later

const i18n: Record<string, any> = {
    de: deLabels
};

export default i18n;
